import React from "react";
import EducationalBookletDetails from "../../components/content/educational-booklet-details/EducationalBookletDetails";

export default class EducationalBookletDetailsRoute extends React.PureComponent<{ bookletId?: string | null }> {
    constructor(props: any) {
        super(props);
    }

    render(): React.ReactNode {
        return this.props.bookletId != null ? <div><EducationalBookletDetails id={Number(this.props.bookletId)} /></div> : null
    }
}